import React from "react";
import styles from "./CheckInputArea.module.scss";
import { GroupedInputOptions } from "../../utils/GeneralUtils";
import CheckInput from "./CheckInput";

type Props = {
  name: string;
  checkOptions: GroupedInputOptions | Array<[string, string]>;
  baseColor: "black" | "white";
  checked: Array<string>;
  handleChange: (value: string) => void;
};
const CheckInputArea: React.FC<Props> = ({
  name,
  checkOptions,
  baseColor,
  checked,
  handleChange,
}) => {
  const isNormalOptions = (
    options: any
  ): options is Array<[string, string]> => {
    if (!Array.isArray(options) || !options[0]) return false;

    return options.every(
      (option) =>
        Array.isArray(option) &&
        option.length === 2 &&
        typeof option[0] === "string" &&
        typeof option[1] === "string"
    );
  };

  if (isNormalOptions(checkOptions)) {
    return (
      <div className={styles["checkInput-area"]}>
        {checkOptions.map((value) => (
          <CheckInput
            baseColor={baseColor}
            key={value[0]}
            id={value[0]}
            name={name}
            initial_value={checked.includes(value[0])}
            label={value[1]}
            handler={handleChange}
          />
        ))}
      </div>
    );
  } else {
    return (
      <div className={styles["checkInput-group"]}>
        {checkOptions.map((group) => (
          <div key={group.name} className={styles["checkInput-group__item"]}>
            <div className={styles["checkInput-group__item__name"]}>
              {group.name}
            </div>
            <div className={styles["checkInput-area"]}>
              {group.options.map((value) => (
                <CheckInput
                  baseColor={baseColor}
                  key={value[0]}
                  id={value[0]}
                  name={name}
                  initial_value={checked.includes(value[0])}
                  label={value[1]}
                  handler={handleChange}
                />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }
};

export default CheckInputArea;
